export enum Transmission {
	Automatic = 'Automatic',
	CVT = 'CVT',
	Manual = 'Manual',
	Other = 'Other',
	SemiAutomatic = 'Semi-automatic',
}
